export default __webpack_public_path__ + "static/img-credit-score-old-vs-new--mobile-e19b358985b4e36e9fc669310104d1a6.jpg";